export default __webpack_public_path__ + "static/media/selector.5ad09a16.png";